import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import FromFieldText from '../../atoms/FromFieldText';
import {
    getERAssesmentData,
    getERAssignmentData,
    saveERAssessment,
    saveERAssessmentMaterial,
} from '../../services/user.service';
import * as CryptoJS from "crypto-js";
import FromFieldDate from "../../atoms/FromFieldDate";
import FromFieldDateHari from "../../atoms/FromFieldDateHari";
import FromSpFieldTextAreaHari from "../../atoms/FromSpFieldTextAreaHari";


import AWS from 'aws-sdk';
import FromFieldTextER from "../../atoms/FromFieldTextER";
// Configure AWS with your credentials
AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    region: process.env.REACT_APP_AWS_BUCKET_REGION,
});
const s3 = new AWS.S3();

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

function ERAssessmentReport() {
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [aInfo, setAInfo] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);
    const [mInfo, setMInfo] = useState([]);

    const [sericeProviderName, setSericeProviderName] = useState('');
    const [contactName, setContactName] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [mailId, setEmailId] = useState('');
    const [mobileNo, setMobileNo] = useState('');

    const [assignedDate, setAssignedDate] = useState('');
    const [ErrAssignedDate, setErrAssignedDate] = useState('');

    //const [acceptedDate, setAcceptedDate] = useState('');
    //const [ErrAcceptedDate, setErrAcceptedDate] = useState('');

    const [assignmentNumber, setAssignmentNumber] = useState('');
    const [ErrAssignmentNumber, setErrAssignmentNumber] = useState('');

    const [detailProblem, setDetailProblem] = useState('');

    const [detailProblemIdentified, setDetailProblemIdentified] = useState('');
    const [ErrDetailProblemIdentified, setErrDetailProblemIdentified] = useState('');

    const [uploadFile, setUploadFile] = useState('');
    const [uploadFileError, setUploadFileError] = useState('');

    const [uploadScreenShot, setUploadScrrenShot] = useState('');
    const [uploadScrrenShotError, setUploadScrrenShotError] = useState('');

    const [materialUsed, setMaterialUsed] = useState('');
    const [ErrMaterialUsed, setErrMaterialUsed] = useState(false);

    const [formCategory, setFormCategory] = useState('');
    const [ErrFormCategory, setErrFormCategory] = useState(false);

    const [assignedTo, setAssignedTo] = useState('');

    const [invoiceNo, setInvoiceNo] = useState('');
    const [ErrInvoiceNo, setErrInvoiceNo] = useState(false);

    const [invoiceDate, setInvoiceDate] = useState('');
    const [ErrInvoiceDate, setErrInvoiceDate] = useState(false);

    const [invoiceAmount, setInvoiceAmount] = useState('');
    const [ErrInvoiceAmount, setErrInvoiceAmount] = useState(false);

    const [nextServiceDue, setNextServiceDue] = useState('');
    const [ErrNextServiceDue, setErrNextServiceDue] = useState(false);

    const [nextServiceDate, setNextServiceDate] = useState('');
    const [ErrNextServiceDate, setErrNextServiceDate] = useState(false);

    const [closingNote, setClosingNote] = useState('');
    const [ErrClosingNote, setErrClosingNote] = useState(false);

    const [repairCategory, setRepairCategory] = useState('');
    const [ErrRepairCategory, setErrRepairCategory] = useState(false);

    const [materials, setMaterials] = useState([{
        date: '',
        name: '',
        partNumber: '',
        make: '',
        model: '',
        serialNo: '',
        qty: '',
        cost: ''
    }]);

    const [showTextField, setShowTextField] = useState(false);
    const [equipmentList, setEquipmentList] = useState([]);

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const resetUserInfo = () => {
        setDetailProblemIdentified('');
        setAssignmentNumber('');
        setClosingNote('');
        setNextServiceDue('');
        setNextServiceDate('');
        setInvoiceAmount('');
        setInvoiceNo('');
        setInvoiceDate('');
        setMaterialUsed('');

    };
    const params = new URLSearchParams(window.location.search);
    const encryptedAssignmentNO = params.get('assignmentNos');
    useEffect(() => {

        if (encryptedAssignmentNO) {
            setIsUpdate(true); // Flag to indicate update mode

            if (encryptedAssignmentNO !== '' && encryptedAssignmentNO !== null) {
                const decryptedBytes = CryptoJS.AES.decrypt(encryptedAssignmentNO.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                // Convert the decrypted bytes to a string
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                const decryptCommentId = decrypt_data.assignment_no;
                setAssignmentNumber(decryptCommentId);
                getTagInfo(decryptCommentId); // get comment info
            }
        }
    }, []);


    useEffect(() => {
    if (mInfo.length > 0) {
        const mappedMaterials = mInfo.map(material => ({
            date: material.material_date,
            name: material.material_name,
            partNumber: material.material_partNumber,
            make: material.material_make,
            model: material.material_model,
            serialNo: material.material_serialNo,
            qty: material.material_qty,
            cost: material.material_cost
        }));

        setMaterials(mappedMaterials);
    }
    }, [mInfo]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let valid = true;
        let errorMessages = [];

        if (!invoiceDate) {
            setErrInvoiceDate('Invoice date is required');
            valid = false;
        } else {
            setErrInvoiceDate('');
        }
        if (!invoiceNo) {
            setErrInvoiceNo('Invoice no is required');
            valid = false;
        } else {
            setErrInvoiceNo('');
        }if (!invoiceAmount) {
            setErrInvoiceAmount('Invoice amount is required');
            valid = false;
        } else if (isNaN(invoiceAmount) || Number(invoiceAmount) <= 0) {
            setErrInvoiceAmount('Enter a valid number for the invoice amount');
            valid = false;
        } else {
            setErrInvoiceAmount('');
        }
        if (!closingNote) {
            setErrClosingNote('Please select closing note');
            valid = false;
        } else {
            setErrClosingNote('');
        }
        if (!nextServiceDue) {
            setErrNextServiceDue('Please select yes or no');
            valid = false;
        } else {
            setErrNextServiceDue('');
        }
        if (nextServiceDue === "Yes") {
            if (!nextServiceDate) {
                setErrNextServiceDate('Next Service Date is required');
                valid = false;
            }
        }
        if (uploadFileError) {
            errorMessages.push(uploadFileError);
            valid = false;
        }
        if (uploadScrrenShotError) {
            errorMessages.push(uploadScrrenShotError);
            valid = false;
        }

        if (!valid) {
            //console.log("Form submission errors:", errorMessages);
            ///alert(`Error: Please fix the following issues:\n\n${errorMessages.join('\n')}`);
        } else {
            saveData();
            //console.log("Form submitted successfully");
        }
    };

    const handleUploadFile = (e) => {
        const files = Array.from(e.target.files); // Convert FileList to array
        const validFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
        const maxSize = 5 * 1024 * 1024; // 2 MB
        const maxFiles = 5;
        let errorMsg = '';
        let validFiles = [];

        if (files.length > maxFiles) {
            setUploadFileError(`You can only upload up to ${maxFiles} files.`);
            setUploadFile([]);
            return;
        } else {
            for (let file of files) {
                if (!validFileTypes.includes(file.type)) {
                    errorMsg = 'Only JPEG, PNG, and PDF files are allowed.';
                    break;
                }
                if (file.size > maxSize) {
                    errorMsg = 'File size should not exceed 5 MB.';
                    break;
                }
                validFiles.push(file);
            }
        }

        if (errorMsg) {
            setUploadFileError(errorMsg);
            setUploadFile([]);
        } else {
            setUploadFileError('');
            setUploadFile(validFiles);
        }
    };
    const handleUploadScreenshot = (e) => {
        const files = Array.from(e.target.files); // Convert FileList to array
        const validFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
        const maxSize = 5 * 1024 * 1024; // 2 MB
        const maxFiles = 5;
        let errorMsg = '';
        let validFiles = [];

        if (files.length > maxFiles) {
            setUploadScrrenShotError(`You can only upload up to ${maxFiles} screenshot.`);
            setUploadScrrenShot([]);
            return;
        } else {
            for (let file of files) {
                if (!validFileTypes.includes(file.type)) {
                    errorMsg = 'Only JPEG, PNG, and PDF files are allowed.';
                    break;
                }
                if (file.size > maxSize) {
                    errorMsg = 'File size should not exceed 5 MB.';
                    break;
                }
                validFiles.push(file);
            }
        }

        if (errorMsg) {
            setUploadScrrenShotError(errorMsg);
            setUploadScrrenShot([]);
        } else {
            setUploadScrrenShotError('');
            setUploadScrrenShot(validFiles);
        }
    };
    const saveData = () => {
        try {

            let imgNames = [];
            let screenshotNames = [];
            const dir_path = sessionStorage.getItem("LoggedInCompanyShortName");
            if (uploadFile && uploadFile.length > 0) {
                uploadFile.forEach((file, idx) => {
                    const ext = file.name.split('.').pop();
                    const imgName = `${assignmentNumber}_${idx + 1}.${ext}`;
                    uploadFileServer(file, imgName);
                    imgNames.push(`${dir_path}/external_repair/era_upload_file_${imgName}`);
                });
            }

            if (uploadScreenShot && uploadScreenShot.length > 0) {
                uploadScreenShot.forEach((file, idx) => {
                    const ext = file.name.split('.').pop();
                    const screenshotName = `${assignmentNumber}_screenshot_${idx + 1}.${ext}`;
                    uploadFileServer(file, screenshotName);
                    screenshotNames.push(`${dir_path}/external_repair/era_screenshots_${screenshotName}`);
                });
            }

            var obj = {

                'assignment_no': assignmentNumber,
                //'problem_desc': detailProblem,
                'detail_problem_identified': detailProblemIdentified,
                'upload_files': imgNames.join(','),
                'upload_scrrenshots': screenshotNames.join(','),
                'materialUsed': materialUsed,
                'invoice_no': invoiceNo,
                'invoice_date': (invoiceDate?getFormatedDate(invoiceDate):''),
                'invoice_amount': invoiceAmount,
                'nextServiceDue': nextServiceDue,
                'nextServiceDate': (nextServiceDate?getFormatedDate(nextServiceDate):null),
                'handleClosingNote': closingNote,
                'created_by': sessionStorage.getItem('LoggedInUserId'),
            }

            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = {'token': EncryptData};

            saveERAssessment(oData).then(res => {
                if (res.data.errors && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    resetUserInfo();
                }
            });

            var obj1 = {

                'assignment_no': assignmentNumber,
                'handleClosingNote': closingNote,
                'materials': materials.map(material => ({
                    'material_date': material.date,
                    'material_name': material.name,
                    'material_partNumber': material.partNumber,
                    'material_make': material.make,
                    'material_model': material.model,
                    'material_serialNo': material.serialNo,
                    'material_qty': material.qty,
                    'material_cost': material.cost
                })),
                'created_by': sessionStorage.getItem('LoggedInUserId'),
            }

            let EncryptData1 = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj1,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData1 = {'token': EncryptData1};
            saveERAssessmentMaterial(oData1).then(res => {
                if (res.data.errors && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    resetUserInfo();
                }
            });
        } catch (err) {
            setSuccess(false);
            if (!err?.data) {
                setErrMsg('No Server Response');
            } else if (err.data?.status === 409) {
                setErrMsg('Data already exists');
            } else {
                setErrMsg('Insert/Update Failed');
            }
        }
    };

    const uploadFileServer = (file, img_name) => {
        const params = {
            Bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
            Key: 'image/' + img_name, // +'.png', // Replace with your desired S3 key
            Body: file,
        };
        s3.upload(params, (err, data) => {
            if (err) {
                console.error('Error uploading file:', err);
                setErrMsg('Error uploading file');
            } else {
                //console.log('File uploaded successfully:', data);
                return params.name;
            }
        });
    };

    const handleFormCategory = (e) => {
        setFormCategory(e.target.value);
    }

    const handleClosingNote = (e) => {
        setClosingNote(e.target.value);
    }

    // Function to fetch assignment data using decrypted assignment number
    const getTagInfo = (assignmentNo) => {
        if (!assignmentNo) {
            setErrMsg("Invalid assignment number.");
            return;
        }

        const EncryptData = CryptoJS.AES.encrypt(
            JSON.stringify({
                param_data: { assignment_no: assignmentNo },
                authToken: sessionStorage.getItem("LoggedInToken"),
            }),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();

        const oData = { token: EncryptData };

        // Fetch Assessment Data
        getERAssesmentData(oData)
            .then((res) => {
                if (res?.data?.data?.assessment_data) {
                    const firstItem = res.data.data.assessment_data;

                    setErrMsg("");
                    setMInfo(res.data.data.list_material_used || []);
                    setDetailProblemIdentified(firstItem.detail_problem_identified);
                    setMaterialUsed(firstItem.materialUsed);
                    setInvoiceNo(firstItem.invoice_no);
                    setInvoiceDate(new Date(firstItem.invoice_date));
                    setInvoiceAmount(firstItem.invoice_amount);
                    setNextServiceDue(firstItem.nextServiceDue);
                    setNextServiceDate(new Date(firstItem.nextServiceDate));
                    setClosingNote(firstItem.handleClosingNote);
                }
            })
            .catch((error) => {
                console.error("Error fetching assessment data:", error);
                setErrMsg("Failed to fetch assessment data.");
            });

        // Fetch Assignment Data
        getERAssignmentData(oData)
            .then((res) => {
                if (res?.data?.data?.length > 0) {
                    const firstItem = res.data.data[0];

                    setErrMsg("");
                    setAssignedTo(firstItem.endUser_name);
                    setAssignedDate(new Date(firstItem.assignedDate));
                    setFormCategory(firstItem.cat_ir);
                    setRepairCategory(firstItem.service_name);
                    setDetailProblem(firstItem.problem_details);
                    setMobileNo(firstItem.mobile_no);
                    setEmailId(firstItem.contact_email);
                    setContactNumber(firstItem.contact_no);
                    setContactName(firstItem.contact_person);
                    setSericeProviderName(firstItem.provider_name);
                    setAInfo(res.data.data);

                    var aInfo1 = res.data.equipment;
                    setEquipmentList(aInfo1);
                } else {
                    setErrMsg("Assignment no not found.");
                    setAInfo([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching assignment data:", error);
                setErrMsg("Failed to fetch assignment data.");
                setAInfo([]);
            });
    };

    const handleMaterial = (e) => {
        const { value } = e?.target || {};  // Ensure target exists
        if (value) {
            setMaterialUsed(value);
        }
    };

    const handleServices = (event) => {
        const value = event.target.value;
        setNextServiceDue(event.target.value);
        setShowTextField(value === "Yes");
    }

    const addRow = () => {
        setMaterials([...materials, {
            date: '',
            name: '',
            partNumber: '',
            make: '',
            model: '',
            serialNo: '',
            qty: '',
            cost: ''
        }]);
    };

    const removeRow = () => {
        if (materials.length > 1) {
            setMaterials(materials.slice(0, -1));
        }
    };

    const handleSearchInputChange = (event) => {
        const { name, value } = event?.target || {};
        if (!name) return;
        setAssignmentNumber(value);
    };
    const handleInputChange = (index, event) => {
        const { name, value } = event?.target || {};  // Destructure name and value from event.target
        if (!name) return;  // Prevent further execution if name is undefined


        const updatedMaterials = materials.map((material, i) => (
            i === index ? { ...material, [name]: value } : material
        ));
        setMaterials(updatedMaterials);
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-6">
                    <h5>{isUpdate ? 'Update ER Assessment Report' : 'ER Assessment Report'}</h5>
                </div>
                <div className="invalid-feedback" role="alert">
                    <i className="fa fa-info-circle"></i>
                    Please Fill all mandatory fields.
                </div>

                {success ? (
                    <div className="alert alert-success" role="alert">
                        <i className="bi bi-check-circle-fill"></i>{success}
                    </div>
                ) : (
                    errMsg && (
                        <div className="alert alert-danger" role="alert">
                            <i className="bi bi-exclamation-triangle-fill"></i>{errMsg}
                        </div>
                    )
                )}
            </div>


            <div className='row '>
                <div className='col-12'>&nbsp;</div>

                {(encryptedAssignmentNO)?(""): (<div className='row'>
                    <div className='col'><h5 className='align-right'>Assignment No </h5></div>
                    <div className='col'>
                        <input name="assignmentNumber"
                               onChange={handleSearchInputChange}
                            value={assignmentNumber}  // Set the value from state
                            type="text"
                            className="form-control"
                            placeholder='Enter the assignment no'
                        />
                        <p className='invalid-feedback'>{ErrAssignmentNumber}</p>
                    </div>
                    <div className='col'>
                        <button onClick={() => getTagInfo(assignmentNumber)} className='btn btn-info btn-md'>
                            <i className="bi bi-search"></i> Search
                        </button>

                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href={'/ir-assessment-report'}>
                        <button className='btn btn-secondary btn-md'><i className="bi bi-arrow-clockwise"></i> Reset</button>
                    </a>&nbsp;</div>
                </div>)}

            </div>
            <div className='row'></div>

            <div className="row">

                <form onSubmit={handleSubmit}>

                    <div className="row mt-2">

                        <div className="col-6">
                            <div className="row">
                                
                            </div>
                        </div>
                    </div>

                    <div className="row mt-2">

                        <div className='col-md-6'>
                            <div className="row"> 
                                <div className="col-md-6"><label> FORM Category </label></div> 
                                <div className="col-md-6"><select disabled onChange={handleFormCategory} name="formCategory"
                                            className="form-select form-select-sm">
                                        <option value="">Select Form Category</option>
                                        <option value="IRAI"
                                                selected={formCategory === "ERAI" ? "selected" : ''}>IT Assets
                                        </option>
                                        <option value="IRAO"
                                                selected={formCategory === "ERAO" ? "selected" : ''}>Other Asset
                                        </option>
                                    </select>
                                    <span className="invalid-feedback">{ErrFormCategory} </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                        <FromFieldDate
                                readOnly={true}
                                label="Assigned Date" star="*" placeholder="YYYY-MM-DD"
                                inputValue={assignedDate}
                                setInputValue={setAssignedDate}
                                setErrorMsg={ErrAssignedDate}
                            />  
                        </div>
                    </div>

                    <div className="row mt-2">

                        <div className='col-md-6'>
                        <FromFieldText
                                readOnly={true}
                                star="*"
                                label="Assignment Number"
                                inputValue={assignmentNumber}
                                setInputValue={setAssignmentNumber}
                                setErrorMsg={setErrAssignmentNumber}
                                errorMsg={ErrAssignmentNumber}
                            />
                        </div>
                        <div className='col-md-6'>
                            <FromFieldText
                                readOnly={true}
                                star="*"
                                label="Assigned To"
                                placeholder="Assigned To User Name"
                                inputValue={assignedTo}
                                setInputValue={setAssignedTo}
                            />
                        </div>
                    </div>

                    <div className="row mt-2">

                        <div className="col-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <label> Repair Category </label>
                                    <span className="star error">  </span>
                                </div>
                                <div className="col-md-6">
                                    <select disabled onChange={handleFormCategory} name="alternative_verification"
                                            className="form-select form-select-sm">
                                        <option value="">Select Form repair Category</option>
                                        <option value="AMC"
                                                selected={repairCategory === "AMC" ? "selected" : ''}>AMC
                                        </option>
                                        <option value="Warranty"
                                                selected={repairCategory === "Warranty" ? "selected" : ''}>warranty
                                        </option>
                                        <option value="Insurance"
                                                selected={repairCategory === "Insurance" ? "selected" : ''}>Insurance
                                        </option>
                                        <option value="Paid service"
                                                selected={repairCategory === "Paid service" ? "selected" : ''}>Paid
                                            service
                                        </option>
                                        <option value="Commercial"
                                                selected={repairCategory === "Commercial" ? "selected" : ''}>Commercial
                                        </option>
                                        <option value="Others"
                                                selected={repairCategory === "Others" ? "selected" : ''}>Others
                                        </option>
                                    </select>
                                    <span className="invalid-feedback">{ErrRepairCategory} </span>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <FromFieldText
                                readOnly={true}
                                star="*"
                                label="Service Provider Name"
                                placeholder="Service Provider Name"
                                inputValue={sericeProviderName}
                                setInputValue={setSericeProviderName}
                            />
                        </div>

                    </div>

                    <div className="row mt-2">

                        <div className='col-md-6'>
                            <FromFieldText
                                readOnly={true}
                                label="Contact Person Name" star="*" placeholder="Contact Person Name"
                                inputValue={contactName}
                                setInputValue={setContactName}
                            />
                        </div>
                        <div className="col-6">
                            <FromFieldText
                                readOnly={true}
                                star="*"
                                label="Contact Number" placeholder="Contact Number"
                                inputValue={contactNumber}
                                setInputValue={setContactNumber}
                            />
                        </div>
                    </div>

                    <div className="row mt-2">

                        <div className='col-md-6'>
                            <FromFieldText
                                readOnly={true}
                                label="Mail ID" star="*" placeholder="Mail Id"
                                inputValue={mailId}
                                setInputValue={setEmailId}
                            />
                        </div>
                        <div className="col-6">
                            <FromFieldText
                                readOnly={true}
                                star="*"
                                label="Mobile No" placeholder="Mobile no"
                                inputValue={mobileNo}
                                setInputValue={setMobileNo}
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <h6 className="text-center">List of Equipment</h6>
                        <table className="table table-bordered equipment-table">
                            <thead className="text-center">
                            <tr>
                                <th>Sl #</th>
                                <th>TAG No</th>
                                <th>TAG Name</th>
                                <th>Item Description</th>
                            </tr>
                            </thead>
                            <tbody className="text-center">
                            {equipmentList && equipmentList.length > 0 ? (
                                equipmentList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        {/* Serial number (starts from 1) */}
                                        <td>{item.tag}</td>
                                        {/* Equipment tag */}
                                        <td>{item.tag_name || "N/A"}</td>
                                        {/* Equipment tag name (fallback to 'N/A') */}
                                        <td>{item.equipment_desc || "N/A"}</td>
                                        {/* Equipment description (fallback to 'N/A') */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4">No equipment data available</td>
                                </tr>
                            )}
                            </tbody>

                        </table>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label>Brief description of the problem reported <span className="error">*</span></label>
                        </div>
                        <div className='col-md-6'>
                            <FromSpFieldTextAreaHari maxLength="2000" numRows="5"
                                                     readOnly={true}
                                                     inputValue={detailProblem}
                                                     setInputValue={setDetailProblem}
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label>Brief description of the actual problem identified<span
                                className="error">*</span></label>
                        </div>
                        <div className='col-md-6'>
                            <FromSpFieldTextAreaHari maxLength="2000" numRows="5"
                                                     inputValue={detailProblemIdentified}
                                                     setInputValue={setDetailProblemIdentified}
                                                     setErrorMsg={ErrDetailProblemIdentified}
                            />
                        </div>
                    </div>
                    <div>
                        <div className="row mt-3">
                            <div className="col-md-12">
                                <label>Upload Files of the Problem (if applicable)</label>
                                <br/>
                                <small className="form-text text-muted">Only JPEG, PNG, and PDF files are allowed.
                                    Maximum
                                    size: 5 MB. Maximum 5 files allowed at
                                    once. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small>
                                <input type="file" name="uploadFile" multiple onChange={handleUploadFile}/>
                                <span className="invalid-feedback">{uploadFileError}</span>
                            </div>
                        </div>
                        <div>
                            <div className="col-md-12 mt-3">
                                <label>Upload Screenshots of the Problem (if
                                    applicable) &nbsp;&nbsp;&nbsp;&nbsp;</label>
                                <br/>
                                <small className="form-text text-muted">Only JPEG, PNG, and PDF files are allowed.
                                    Maximum
                                    size: 5 MB. Maximum 5 files allowed
                                    once.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small>
                                <input type="file" name='uploadScreenshot' multiple
                                       onChange={handleUploadScreenshot}/>
                                <span className="invalid-feedback"> {uploadScrrenShotError} </span>
                            </div>

                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label> Any Materials Used <span className="error">*</span></label>
                            <span className="star error">  </span>
                        </div>
                        <div className="col-md-3">
                            <select onChange={handleMaterial} name="materialUsed"
                                    className="form-select form-select-sm" value={materialUsed}>
                            <option value="">Select Material Used or not</option>
                            <option value="Yes" selected={materialUsed === "Yes" ? "selected" : ''}>Yes
                                </option>
                            <option value="No" selected={materialUsed === "No" ? "selected" : ''}>No
                                </option>
                            </select>
                            <span className="invalid-feedback">{ErrMaterialUsed}</span>
                        </div>
                    </div>

                    {/* Conditionally render the table if materialUsed is "Yes" */}
                    {materialUsed === "Yes" && (
                        <div className="row mt-3" style={{maxHeight: '350px', overflowY: 'auto'}}>
                            <h6 className="text-center">List of Material Used</h6>
                            <table className="table table-bordered">
                                <thead className="text-center">
                                <tr>
                                    <th>Sl #</th>
                                    <th>Date</th>
                                    <th>Material Name</th>
                                    <th>Part Number</th>
                                    <th>Make</th>
                                    <th>Model</th>
                                    <th>Serial No</th>
                                    <th>Qty</th>
                                    <th>Cost</th>
                                </tr>
                                </thead>
                                <tbody className="text-center">
                                {materials.map((material, index) => (

                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td><input type="date" name="date" value={material.date}
                                                   onChange={(e) => handleInputChange(index, e)}/></td>
                                        <td><input type="text" name="name" value={material.name}
                                                   onChange={(e) => handleInputChange(index, e)}/></td>
                                        <td><input type="text" name="partNumber" value={material.partNumber}
                                                   onChange={(e) => handleInputChange(index, e)}/></td>
                                        <td><input type="text" name="make" value={material.make}
                                                   onChange={(e) => handleInputChange(index, e)}/></td>
                                        <td><input type="text" name="model" value={material.model}
                                                   onChange={(e) => handleInputChange(index, e)}/></td>
                                        <td><input type="text" name="serialNo" value={material.serialNo}
                                                   onChange={(e) => handleInputChange(index, e)}/></td>
                                        <td><input type="number" name="qty" value={material.qty}
                                                   onChange={(e) => handleInputChange(index, e)}/></td>
                                        <td><input type="number" name="cost" value={material.cost}
                                                   onChange={(e) => handleInputChange(index, e)}/></td>
                                    </tr>
                                ))}
                                {/* Calculate and display totals */}
                                <tr>
                                    <td colSpan="7" className="text-right"><strong>Total</strong></td>
                                    <td>
                                        <strong>{materials.reduce((acc, material) => acc + Number(material.qty || 0), 0)}</strong>
                                    </td>
                                    <td>
                                        <strong>{materials.reduce((acc, material) => acc + Number(material.cost || 0), 0).toFixed(2)}</strong>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            {/* Add/Remove Row Buttons */}
                            <div className="text-center mt-2">
                                <div className="text-center mt-2">
                                    <button type="button" className="btn btn-primary btn-sm mx-2" onClick={addRow}>Add
                                        Row
                                    </button>
                                    <button type="button" className="btn btn-danger btn-sm mx-2"
                                            onClick={removeRow}>Remove Row
                                    </button>
                                </div>

                            </div>
                        </div>

                    )}


                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label>Invoice No<span className="error">*</span></label>
                        </div>
                        <div className='col-md-6'>
                            <FromFieldTextER
                                placeholder="Invoice No"
                                inputValue={invoiceNo}
                                setInputValue={setInvoiceNo}
                                setErrorMsg={ErrInvoiceNo}
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-3">
                            <label>Invoice Date<span className="error">*</span></label>
                        </div>
                        <div className='col-md-6'>
                            <FromFieldDate
                                //label="Invoice Date" star="*" 
                                placeholder="YYYY-MM-DD"
                                inputValue={invoiceDate}
                                setInputValue={setInvoiceDate}
                                setErrorMsg={ErrInvoiceDate}
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label>Invoice Amount with Tax<span className="error">*</span></label>
                        </div>
                        <div className='col-md-6'>
                            <FromFieldTextER
                                placeholder="Invoice Amount with Tax"
                                inputValue={invoiceAmount}
                                setInputValue={setInvoiceAmount}
                                setErrorMsg={ErrInvoiceAmount}
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label>Next Service Due (if Any)<span
                                className="error">*</span></label>
                            <span className="star error"></span>
                        </div>
                        <div className="col-md-3">
                            <select onChange={handleServices} name="nextServiceDue"
                                    className="form-select form-select-sm">
                                <option value="">Select Service Due</option>
                                <option value="Yes" selected={nextServiceDue === "Yes"}>Yes</option>
                                <option value="No" selected={nextServiceDue === "No"}>No</option>
                            </select>
                            <span className="invalid-feedback">{ErrNextServiceDue}</span>
                        </div>
                    </div>

                    {showTextField && (
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <label>If Yes, select the date<span className="error">*</span></label>
                            </div>
                            <div className="col-md-6">
                                <FromFieldDateHari
                                    maxLength={2000}
                                    numRows={5}
                                    className="form-control"
                                    inputValue={nextServiceDate}
                                    setInputValue={setNextServiceDate}
                                    onChange={(e) => setNextServiceDate(e.target.value)}
                                />
                                <span className="invalid-feedback">{ErrNextServiceDate}</span>
                            </div>
                        </div>
                    )}

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label> Closing Note <span
                                className="error">*</span></label>
                            <span className="star error">  </span>
                        </div>
                        <div className="col-md-3">
                            <select onChange={handleClosingNote} name="alternative_verification"
                                    className="form-select form-select-sm">
                                <option value="">Select Closing Note</option>
                                <option value="4"
                                        selected={closingNote === "4" ? "selected" : ''}>Repair Completed - Asset Working
                                </option>
                                <option value="5"
                                        selected={closingNote === "5" ? "selected" : ''}>Recommended for Disposal
                                </option>
                            </select>
                            <span className="invalid-feedback">{ErrClosingNote} </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12">
                        </div>
                    </div>

                    <div className="row mt-4 mb-2">
                        {(isUpdate) ? (<div className="col-md-12 d-flex justify-content-center">
                            <button type="submit" className="btn btn-primary btn-md"> Update </button>
                            <button
                                type="button"
                                className="btn btn-secondary btn-sm ms-3"  // Left margin for spacing
                                onClick={resetUserInfo}
                            ><i className="bi bi-arrow-clockwise"></i> Reset </button>
                        </div>) : (<div className="col-md-12 d-flex justify-content-center">
                            <button type="submit" className="btn btn-primary btn-md"> Submit Report </button>
                            <button
                                type="button"
                                className="btn btn-danger btn-sm ms-3"  // Left margin for spacing
                                onClick={resetUserInfo}
                            ><i className="bi bi-arrow-clockwise"></i> Reset </button>
                        </div>)}


                    </div>

                </form>
            </div>
        </div>
    );
}

export default ERAssessmentReport;